module.exports = __webpack_public_path__ + "img/6.cd14e5d2.jpg";